<template>
  <div class="user-avatar" :style="{'width':width}">
    <div class="avatar-etiquet" v-if="isGlobalScot && showLabel">Service</div>
    <el-avatar
      :shape="shape"
      :size="size"
      :src="src ? src : authorExist ? defaultSrc : '../../static/img/no-avatar.png'"
      :alt="alt"
      :class=" {image: !!addBorder}"
      ><img :src="defaultSrc"
    /></el-avatar>
  </div>
</template>
<script>
export default {
  props: {
    authorExist:{type:Boolean, default:true},
    shape: String,
    size: Number,
    src: String,
    alt: String,
    defaultSrc: {
      type: String,
      default: require("../../../static/img/default-image.png")
    },
    isGlobalScot: { type: Boolean, default: false },
    avatarClasses: String,
    chevronClass:String,
    width:String,
    showLabel:{
      type: Boolean, 
      default: false
    },
    addBorder:{
      type: Boolean,
      default: true
    }
  },
  computed:{
    transform(){
      return `translateY(${this.size*3}%) translateX(-74%)`
    }
  }
};
</script>
<style lang="scss">
.user-avatar {
  position: relative;
  .avatar-etiquet {
    text-align: center;
    padding: 0.3rem 0;
    width: 56%;
    background: #0b3459;
    color: $white;
    position: absolute;
    left: -20px;
    font-size: 1.3rem;
    font-weight: bold;
  }
  .image {
    img {
      border: 4px solid $white;
      background: $white;
    }
  }
}
</style>
